import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const SET_AFFILIATE = 'SET_AFFILIATE'
const LOGOUT_USER = 'LOGOUT_USER'

const affiliate_obj = {
    namespaced: true,
    state: {
        affiliate: {}
    },
    mutations: {
        SET_AFFILIATE (state, data) {
            state.affiliate = data
        },
        LOGOUT_USER (state) {
            state.affiliate = {}
        }
    },
    getters: {
        affiliate (state) {
            return state.affiliate
        }
    },
    actions: {
        // API Calls
        async getAllAffiliate ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('affiliate', {params: {order: data.order, type: data.type}})
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
    
        async checkToken ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                const response = await axios.post('affiliate/check_token', {
                    parent_token: data.parent_token,
                })
                return response.data
            } catch (error) {
                throw error
            }
        },

        async getTotalWithdraw ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('affiliate/totalwithdraw/' + data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getAffiliate ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('affiliate/' + data)
                //console.log('getAffiliate: ', response)
                commit(SET_AFFILIATE, response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getAffiliateLedger ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('affiliateledger/' + data)
                //console.log('getAffiliate: ', response)
                //commit(SET_AFFILIATE, response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getAffiliateByMonth ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('getLottoResultByDate data: ', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('affiliatebymonth/' + data)
                //console.log('getLottoResultByDate response: ', response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async createAfWithdraw ({ dispatch, commit, getters, rootGetters }, data) {
            //console.log('createAffiliate data: ', data)
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.post('affiliatewithdraw', data)
            } catch (error) {
                throw new Error(error)
            }
        },


        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
    }
}

export default affiliate_obj
